import React from 'react';
import StandaloneShell from '../../components/StandaloneShell';
import PermissionGate from '../../components/PermissionGate';
import ReferralPartners from '../ReferralPartners';

export default function ReferralsPage() {
  return (
    <StandaloneShell title="Referrals">
      {({ darkMode, T }) => (
        <PermissionGate module="referrals" moduleName="Referrals">
          <ReferralPartners darkMode={darkMode} T={T} />
        </PermissionGate>
      )}
    </StandaloneShell>
  );
}
